/** @format */
import { css } from 'styled-components';

import { MediaQuery } from '@toucan/client/global/application';

export type MediaQueryColumns = {
    mediaQuery?: MediaQuery;
    columns: number;
};

/**
 * @deprecated use @feather/helpers/styles
 *
 * Return an object-fit style paired with an optional fallback for browsers
 * that don't support it?
 *
 * @param {string} fit The type of fit
 */
export const safeObjectFit = (fit: 'contain' | 'cover') => {
    return css`
        object-fit: ${fit};
        max-width: 100%;
        max-height: 100%;
    `;
};

/**
 * Create CSS string of repeated values columnAmount times
 * This is because css repeat() function doesnt' work correctly in grid-template shorthand
 * https://css-tricks.com/almanac/properties/g/grid-template/#aa-be-cautious-when-using-the-repeat-function
 *
 * @param columnAmount - how many times should we repeat the string?
 * @param value - what should we repeat
 *
 * @return string
 */
export function cssRepeat(columnAmount: number, value: string): string {
    return Array(columnAmount).fill(value).join(' ');
}

export const generateGridTemplateColumns = (
    gridColumns: MediaQueryColumns[] | number
) => {
    const getRepeatedGridTemplateColumns = (columns: number) => css`
        grid-template-columns: ${Array(columns)
            .fill('minmax(0, 1fr)')
            .join(' ')};
    `;

    if (typeof gridColumns === 'number') {
        return getRepeatedGridTemplateColumns(gridColumns);
    }

    return css`
        ${gridColumns.map(({ mediaQuery, columns }) => {
            if (mediaQuery) {
                return css`
                    @media only screen and ${mediaQuery} {
                        ${getRepeatedGridTemplateColumns(columns)}
                    }
                `;
            }

            return getRepeatedGridTemplateColumns(columns);
        })}
    `;
};

export const focusOutline = () => css`
    &:focus {
        outline: 0;

        body:not(.using-mouse) & {
            outline-offset: 0.4rem;
            outline: 0.2rem solid var(--colors-accessibility);
        }
    }
`;
